import { render, staticRenderFns } from "./prdAnexos.vue?vue&type=template&id=5979ed69&scoped=true&"
import script from "./prdAnexos.vue?vue&type=script&lang=js&"
export * from "./prdAnexos.vue?vue&type=script&lang=js&"
import style0 from "./prdAnexos.vue?vue&type=style&index=0&id=5979ed69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979ed69",
  null
  
)

export default component.exports